// This file has js ext. and such module format, because it's used by webpack.

const localeCodes = {
    deDE: 'de-DE',
    enUS: 'en-US',
    enAU: 'en-AU',
    enGB: 'en-GB',
    es419: 'es-419',
    esES: 'es-ES',
    fiFI: 'fi-FI',
    frFR: 'fr-FR',
    frCA: 'fr-CA',
    itIT: 'it-IT',
    jaJP: 'ja-JP',
    koKR: 'ko-KR',
    nlNL: 'nl-NL',
    ptBR: 'pt-BR',
    ptPT: 'pt-PT',
    zhCN: 'zh-CN',
    zhHK: 'zh-HK',
    zhTW: 'zh-TW',
};

const shortToLongLocales = {
    de: 'de-DE',
    en: 'en-US',
    es: 'es-ES',
    fi: 'fi-FI',
    fr: 'fr-FR',
    it: 'it-IT',
    pt: 'pt-BR',
    ja: 'ja-JP',
    zh: 'zh-CN',
    ko: 'ko-KR',
    nl: 'nl-NL',
};

module.exports = {
    localeCodes,
    shortToLongLocales,
};
